import React, { Component } from "react";
import { withLocalize, Translate } from "react-localize-redux";
import translations from "../../translations/verify.json";
import Spinner from "react-bootstrap/Spinner";
import "pure-react-carousel/dist/react-carousel.es.css";
import {
	MDBCarousel,
	MDBCarouselInner,
	MDBCarouselItem,
	MDBView,
	MDBContainer,
} from "mdbreact";
import LinkedinSharePopUp from "../../components/verify/LinkedinSharePopUp";

import no_result from "../../assets/no-result/no-result-image.png";
import ZoomCertificate from "../../components/verify/ZoomCertificate";

import ShareIcons from "../../components/share/ShareIcons";
import RectLoader from "../../components/loaders/Rectangle";

import Color from "../../constants/Color";
import { generatePdfLink } from "../../services/verifiedBackendService/generatePdfLink";
import { handleShareAnon } from "../../services/verifiedBackendService/event";
import {
	searchCredential,
	getPreviewWithDeliveryId,
} from "../../services/verifiedBackendService/search";
import { downloadBakedPng } from "../../services/verifiedBackendService/ims";
import {
	getLinkedInUserIdProxy,
	getLinkedInAccessTokenProxy,
	getLinkedInAccessToken,
} from "../../services/verifiedBackendService/linkedin";
import { getMasterConfig } from "wallet-elementkit/dist/constants/master";
import { UserUtils } from "wallet-elementkit/dist/services";
import { storeItem, getItem } from "../../backend/StorageUtils";
import "../../styles/philipMorris/web.scss";
import "../../styles/philipMorris/mobile.scss";

// const { availWidth } = window.screen;
const { innerWidth } = window;
const masterConfig = getMasterConfig();

class Verify extends Component {
	constructor(props) {
		super(props);
		this.state = {
			certificateName: "",
			issued_by: null,
			url: "",
			badgeUrl: "",
			credno: window.location.pathname.split("/")[3],
			errorMessage: "",
			isMobile: props.isMobile,
			isLoading: true,
			isLoadingPdf: false,
			isLoadingPng: {
				certificate: false,
				badge: false,
			},
			activeImg: "badge",
			dialogOpen: false,
			linkedinAccessToken: "",
			linkedinUserId: "",
			linkedinAuthCode: null,
			isScrollLocked: false,
			design: {},
			badgeDesign: {},
			isExpired: false,
			expireDatePlain: "",
			organizationId: "",
			recipientGroupId: "",
		};
		this.props.addTranslation(translations);
	}
	componentWillReceiveProps(...args) {
		this.setState({
			isMobile: args[0].isMobile,
		});
	}
	componentDidMount() {
		const search = this.props.location.search;
		const linkedinAuthCode = new URLSearchParams(search).get("code");
		if (linkedinAuthCode) {
			this.setState({
				linkedinAuthCode,
			});
			this.shareOnLinkedin();
		}
		this.handleSearch();
	}
	handleClickOpen = () => {
		this.setState({ dialogOpen: true });
	};

	handleClose = () => {
		this.setState({ dialogOpen: false });
	};
	handleSearch = async () => {
		let resp;
		let viewerId = getItem("__uid__");
		if (!viewerId) {
			viewerId = UserUtils.genereateViewerId();
			storeItem("__uid__", viewerId);
		}
		const queries = new URLSearchParams(this.props.location.search);
		const referrerUrl = document.referrer
			? document.referrer
			: queries.get("ref");
		if (this.props.isPreview) {
			const certNo = queries.get("certNo");
			const search = this.props.location.search;
			const lockScroll =
				new URLSearchParams(search).get("lockScroll") === "true";
			resp = await getPreviewWithDeliveryId(
				this.props.deliveryId,
				window.location.pathname.split("/")[1],
				window.location.href,
				certNo
			);
			this.setState({ isScrollLocked: lockScroll });
		} else {
			resp = await searchCredential(
				this.state.credno,
				window.location.pathname.split("/")[1],
				window.location.href,
				referrerUrl || window.location.href,
				viewerId
			);
		}
		if (!resp.success) {
			if (resp.isDeleted) {
				this.setState({
					errorMessage: "deleted",
					isLoading: false,
					issuerEmail: resp.organization.email,
				});
			} else {
				this.setState({ errorMessage: "notFound", isLoading: false });
			}
			return;
		}
		if (!resp.details.organization.logoLink) {
			resp.details.organization.logoLink =
				require("../../assets/fallbacks/organization.svg").default;
		}
		this.setState({
			certificateName: resp.result.name,
			url: resp.result.url || "",
			badgeUrl: resp.result.badgeUrl || "",
			badgeDesign: resp.details.badgeDesign || null,
			design: resp.details.certificateDesign || null,
			issued_by: resp.result.issued_by,
			expireDatePlain: resp.details.detail.expireDate || "",
			isExpired: resp.details.isExpired,
			isLoading: false,
			organizationId: resp.details.organization.id,
			recipientGroupId: resp.details.recipientGroupId,
			socialShareText: resp.details.socialSharingText,
		});
	};

	downloadPdf = async () => {
		this.setState({ isLoadingPdf: true });
		let response = await generatePdfLink(this.state.credno);
		if (!response.hasError) {
			await handleShareAnon(
				"pdf",
				this.state.credno,
				this.state.organizationId
			);
			var downEl = document.createElement("a");
			downEl.setAttribute("href", response.data.link);
			downEl.setAttribute("download", this.state.credno);
			downEl.style.display = "none";
			document.body.appendChild(downEl);
			downEl.click();
			document.body.removeChild(downEl);
		}
		this.setState({ isLoadingPdf: false });
	};
	downloadPNG = async (type) => {
		this.setState({
			isLoadingPng:
				type === "badge"
					? { certificate: false, badge: true }
					: { certificate: true, badge: false },
		});
		if (this.state.badgeUrl && this.state.url) {
			if (type === "badge") await downloadBakedPng(this.state.credno);
			else window.open(this.state.url);
		} else {
			await downloadBakedPng(this.state.credno);
		}
		this.setState({
			isLoadingPng: {
				certificate: false,
				badge: false,
			},
		});
	};

	resetLinkedinAuthCode = () => {
		this.setState({
			linkedinAuthCode: null,
		});
	};

	changeActiveImg = (active) => {
		this.setState({
			activeImg: active,
		});
	};

	shareOnLinkedin = async () => {
		if (this.state.linkedinAuthCode && this.state.linkedinAuthCode !== "") {
			await getLinkedInAccessToken(this.state.linkedinAuthCode).then(
				async (tokenCode) => {
					this.setState({ linkedinAccessToken: tokenCode });
					await getLinkedInUserIdProxy(tokenCode).then(async (userId) => {
						this.setState({ linkedinUserId: userId });
						this.handleClickOpen();
					});
				}
			);
		}
	};

	handleMailTo = async (type) => {
		if (this.props.activeLanguage) {
			if (type === "reportNotFound")
				if (this.props.activeLanguage.code === "en")
					window.open(
						`mailto:support@sertifier.com?subject=Certificate Not Found Issue with id ${this.state.credno}&body=Hello, %0D%0AI’m sharing with you my issue with the ${this.state.credno} serial numbered credential.%0D%0A%0D%0ARegards,`
					);
				else
					window.open(
						`mailto:support@sertifier.com?subject=Sertifika Bulunamadı Sorunu sertifika numarası: ${this.state.credno}&body=Merhaba, %0D%0A%0D%0A${this.state.credno} seri numaralı sertifikamla alakalı sorunumu sizinle aşağıda paylaşıyorum.%0D%0A%0D%0ASevgiler,`
					);
			if (type === "deletedCertificate")
				if (this.props.activeLanguage.code === "tr")
					window.open(
						`mailto:${this.state.issuerEmail}?subject=Silinmiş Sertifika, Sertifika numarası: ${this.state.credno}&body=Merhaba, %0D%0A%0D%0A${this.state.credno} seri numaralı sertifikamla alakalı sorunumu sizinle aşağıda paylaşıyorum.%0D%0A%0D%0ASevgiler,`
					);
				else
					window.open(
						`mailto:${this.state.issuerEmail}?subject=Deleted Certificate with id: ${this.state.credno}&body=Hello, %0D%0AI’m sharing with you my issue with the ${this.state.credno} serial numbered credential.%0D%0A%0D%0ARegards,`
					);
		}
	};

	render() {
		if (!this.props.isMobile) {
			return (
				<div
					id="philip-web-main"
					style={
						this.props.isPreview && this.props.isScrollLocked
							? { overflow: "hidden", height: "100vh" }
							: {}
					}
				>
					<div>
						{!this.state.errorMessage ? (
							<div className="flex-column outer-main-philip">
								{this.state.isExpired && (
									<div className="expired-banner">
										<span>
											<Translate id="expiredOn" />
											{this.state.expireDatePlain.split("T")[0]}
											<Translate id="noLongerValid" />
										</span>
									</div>
								)}
								<div className="flex-column inside">
									<div className="certificate-view-main">
										<div className="flex-column inside">
											<div className="flex-row certificate-overview">
												{this.state.isLoading ? (
													<div
														className="certificate-badge-container"
														style={{ minWidth: "500px", maxWidth: "500px" }}
													>
														<RectLoader
															viewBox="0 0 500 350"
															radius="0"
															width="500"
															height="350"
														/>
													</div>
												) : (
													<div className="certificate-badge-container">
														{this.state.design && !this.state.badgeDesign ? (
															<ZoomCertificate
																transform="top left"
																height={350}
																width={1000}
																design={this.state.design}
																isBadge={false}
															/>
														) : (
															""
														)}
														{!this.state.design && this.state.badgeDesign ? (
															<ZoomCertificate
																transform="top left"
																height={500}
																width={500}
																design={this.state.badgeDesign}
																isBadge={true}
															/>
														) : (
															""
														)}
														{this.state.design && this.state.badgeDesign ? (
															<div className="flex-row certificate-badge">
																<div className="flex-column img-select pointer-events-active">
																	<div
																		className="flex-column single-img"
																		style={{
																			backgroundColor:
																				this.state.activeImg === "badge"
																					? "#F0F0F0"
																					: "",
																		}}
																		onClick={() =>
																			this.changeActiveImg("badge")
																		}
																	>
																		<ZoomCertificate
																			transform="top left"
																			height={90}
																			width={90}
																			design={this.state.badgeDesign}
																			isBadge={true}
																		/>
																	</div>
																	<div
																		className="flex-column single-img"
																		style={{
																			backgroundColor:
																				this.state.activeImg === "certificate"
																					? "#F0F0F0"
																					: "",
																		}}
																		onClick={() =>
																			this.changeActiveImg("certificate")
																		}
																	>
																		<ZoomCertificate
																			transform="top left"
																			height={90}
																			width={90}
																			design={this.state.design}
																			isBadge={false}
																		/>
																	</div>
																</div>
																<div className="flex-row real-img-container">
																	{this.state.activeImg === "certificate" ? (
																		<ZoomCertificate
																			transform="top left"
																			height={350}
																			width={1000}
																			design={this.state.design}
																			isBadge={false}
																		/>
																	) : (
																		<ZoomCertificate
																			transform="top left"
																			height={500}
																			width={500}
																			design={this.state.badgeDesign}
																			isBadge={true}
																		/>
																	)}
																</div>
															</div>
														) : (
															""
														)}
													</div>
												)}
											</div>
											<div
												className={`flex-row share ${
													this.props.isPreview ? "no-pointer-event" : ""
												}`}
												style={{
													width: "50%",
												}}
											>
												<div
													className="flex-column"
													style={{ alignItems: "flex-start" }}
												>
													<span className="s3 head">
														<Translate id="share" />
													</span>
													<div className="flex-row social-media-div">
														<ShareIcons
															round={true}
															url={
																window.location.href.toString().split("?")[0]
															}
															certTitle={this.state.certificateName}
															issuer={this.state.issued_by}
															color={Color.darkBlue}
															size={47}
															credential_no={this.state.credno}
															style={{
																marginTop: "-10px",
																marginRight: "20px",
															}}
															linkedinAuthCode={this.state.linkedinAuthCode}
															setLinkedinToken={(newToken) => {
																this.setState({
																	linkedinAccessToken: newToken,
																});
															}}
															setLinkedinUserId={(newId) => {
																this.setState({
																	linkedinUserId: newId,
																});
															}}
															openDialog={this.handleClickOpen}
															closeDialog={this.handleClose}
															language={this.props.activeLanguage}
															organizationId={this.state.organizationId}
															shareText={this.state.socialShareText}
														/>
													</div>
												</div>
												<div className="flex-column download-div">
													<span className="s3 head">
														<Translate id="download" />
													</span>
													{this.state.isLoading ? (
														<div className="flex-row download-div">
															{[1, 2].map((i) => (
																<div
																	key={`download-button-loader-${i}`}
																	style={{
																		width: "50px",
																		height: "20px",
																		marginRight: "30px",
																	}}
																>
																	<RectLoader
																		width={50}
																		height={20}
																		radius={4}
																	/>
																</div>
															))}
														</div>
													) : (
														<div className="flex-row">
															{this.state.badgeDesign ? (
																<div
																	className="flex-row"
																	onClick={() => this.downloadPNG("badge")}
																	style={{
																		cursor: "pointer",
																		marginRight: "30px",
																	}}
																>
																	{this.state.isLoadingPng.badge ? (
																		<Spinner
																			id="pdf-spinner"
																			className="spinner-border"
																			animation="border"
																		/>
																	) : (
																		<img
																			alt="verified"
																			className="download-icon"
																			src={
																				require("../../assets/common/badge-icon-black.svg")
																					.default
																			}
																		/>
																	)}
																	<span className="s4">PNG</span>
																</div>
															) : (
																""
															)}
															{this.state.design ? (
																<div className="flex-row">
																	<div
																		className="flex-row"
																		style={{
																			cursor: "pointer",
																			marginRight: "30px",
																		}}
																		onClick={this.downloadPdf}
																	>
																		{this.state.isLoadingPdf ? (
																			<Spinner
																				id="pdf-spinner"
																				className="spinner-border"
																				animation="border"
																			/>
																		) : (
																			<img
																				alt="verified"
																				className="download-icon"
																				src={
																					require("../../assets/common/certificate-icon-black.svg")
																						.default
																				}
																			/>
																		)}
																		<span className="s4">PDF</span>
																	</div>
																	<div
																		className="flex-row"
																		onClick={() =>
																			this.downloadPNG("certificate")
																		}
																		style={{
																			cursor: "pointer",
																			marginRight: "30px",
																		}}
																	>
																		{this.state.isLoadingPng.certificate ? (
																			<Spinner
																				id="pdf-spinner"
																				className="spinner-border"
																				animation="border"
																			/>
																		) : (
																			<img
																				alt="verified"
																				className="download-icon"
																				src={
																					require("../../assets/common/certificate-icon-black.svg")
																						.default
																				}
																			/>
																		)}
																		<span className="s4">PNG</span>
																	</div>
																</div>
															) : (
																""
															)}
														</div>
													)}
												</div>
											</div>
										</div>
									</div>
								</div>
								{!this.props.isLoading && this.state.dialogOpen ? (
									<LinkedinSharePopUp
										dialogOpen={this.state.dialogOpen}
										handleClose={this.handleClose}
										resetLinkedinAuthCode={this.resetLinkedinAuthCode}
										handleUncreatedImage={this.state.handleUncreatedImage}
										url={
											this.state.url && !this.state.badgeUrl
												? this.state.url
												: this.state.badgeUrl
										}
										issued_by={this.state.issued_by}
										credential_name={this.state.certificateName}
										articleUrl={window.location.href.toString().split("?")[0]}
										tokenCode={this.state.linkedinAccessToken}
										addTranslation={this.props.addTranslation}
										translate={this.props.translate}
										userId={this.state.linkedinUserId}
										credential_no={this.state.credno}
										organizationId={this.state.organizationId}
										certificate_url={this.state.url}
										badge_url={this.state.badgeUrl}
										shareText={this.state.socialShareText}
									/>
								) : null}
							</div>
						) : (
							<div className="div-out">
								<div
									className="main-container"
									style={{
										flexDirection: "column",
										justifyContent: "flex-start",
										width: "fit-content",
										backgroundColor: "transparent",
									}}
								>
									<span style={{ fontSize: "36px", fontWeight: "780" }}>
										<Translate id="notFound1" />
									</span>
									<span style={{ fontSize: "24px", fontWeight: "0px" }}>
										<Translate id={`${this.state.errorMessage}2`} />
									</span>
									<span
										className="report-issue"
										onClick={() => {
											this.state.errorMessage === "deleted"
												? this.handleMailTo("deletedCertificate")
												: this.handleMailTo("reportNotFound");
										}}
									>
										<Translate
											id={
												this.state.errorMessage === "deleted"
													? "contactIssuer"
													: "reportIssue"
											}
										/>
									</span>
									<img
										alt="verified"
										src={no_result}
										style={{ height: "300px", paddingTop: "1%" }}
									/>
								</div>
							</div>
						)}
					</div>
				</div>
			);
		} else {
			return (
				<div
					id="philip-mobile-main"
					style={
						this.props.isPreview
							? {
									marginTop: "0px",
							  }
							: {}
					}
				>
					<div>
						{!this.state.errorMessage ? (
							<div className="certificate-view-main-mobile-philip">
								{this.state.isExpired && (
									<div className="flex-column expired-banner">
										<span>
											<Translate id="expiredOn" />
											{this.state.expireDatePlain.split("T")[0]}
											<Translate id="noLongerValid" />
										</span>
									</div>
								)}
								<div className="flex-column inside">
									<div className="flex-column certificate-overview">
										{this.state.isLoading ? (
											<div className="certificate-loader">
												<RectLoader
													width={innerWidth - 32}
													height={(innerWidth - 32) * 0.7075}
													radius="4"
												/>
											</div>
										) : (
											<div className="certificate-badge-container">
												{this.state.design && !this.state.badgeDesign ? (
													<div
														className="cert-container"
														style={{ width: innerWidth - 72 }}
													>
														<ZoomCertificate
															height={229}
															width={innerWidth - 72}
															design={this.state.design}
															isBadge={false}
														/>
													</div>
												) : (
													""
												)}
												{!this.state.design && this.state.badgeDesign ? (
													<div
														className="cert-container"
														style={{ width: innerWidth - 72 }}
													>
														<ZoomCertificate
															height={180}
															width={180}
															design={this.state.badgeDesign}
															isBadge={true}
														/>
													</div>
												) : (
													""
												)}
												{this.state.design && this.state.badgeDesign ? (
													<div className="carousel-my pointer-events-active">
														<MDBContainer>
															<MDBCarousel
																activeItem={1}
																length={2}
																showControls={true}
																showIndicators={false}
																className="z-depth-1"
																slide={false}
																interval={9999999}
															>
																<MDBCarouselInner>
																	<MDBCarouselItem itemId="1">
																		<MDBView>
																			<div className="flex-column carousel-img">
																				<div
																					className="cert-container"
																					style={{ width: innerWidth - 72 }}
																				>
																					<ZoomCertificate
																						height={180}
																						width={180}
																						design={this.state.badgeDesign}
																						isBadge={true}
																					/>
																				</div>
																			</div>
																		</MDBView>
																	</MDBCarouselItem>
																	<MDBCarouselItem itemId="2">
																		<MDBView>
																			<div className="flex-column carousel-img">
																				<div
																					className="cert-container"
																					style={{ width: innerWidth - 72 }}
																				>
																					<ZoomCertificate
																						height={229}
																						width={innerWidth - 72}
																						design={this.state.design}
																						isBadge={false}
																					/>
																				</div>
																			</div>
																		</MDBView>
																	</MDBCarouselItem>
																</MDBCarouselInner>
															</MDBCarousel>
														</MDBContainer>
													</div>
												) : (
													""
												)}
											</div>
										)}
									</div>
									<div
										className={`flex-column share ${
											this.props.isPreview ? "no-pointer-event" : ""
										}`}
									>
										<div
											className="flex-column"
											style={{ alignItems: "flex-start" }}
										>
											<span className="s3 head">
												<Translate id="share" />
											</span>
											<div className="flex-row social-media-div">
												<ShareIcons
													round={true}
													url={window.location.href.toString().split("?")[0]}
													certTitle={this.state.certificateName}
													issuer={this.state.issued_by}
													color={Color.darkBlue}
													size={47}
													credential_no={this.state.credno}
													linkedinAuthCode={this.state.linkedinAuthCode}
													setLinkedinToken={(newToken) => {
														this.setState({ linkedinAccessToken: newToken });
													}}
													setLinkedinUserId={(newId) => {
														this.setState({
															linkedinUserId: newId,
														});
													}}
													openDialog={this.handleClickOpen}
													closeDialog={this.handleClose}
													style={{ marginTop: "-10px" }}
													organizationId={this.state.organizationId}
												/>
											</div>
										</div>
										<div className="flex-column download-div">
											<span className="s3 head">
												<Translate id="download" />
											</span>
											{this.state.isLoading ? (
												<div className="flex-row">
													{[1, 2].map((i) => (
														<div
															key={`download-button-loader-${i}`}
															style={{
																width: "50px",
																height: "20px",
																marginRight: "30px",
															}}
														>
															<RectLoader width={50} height={20} radius={4} />
														</div>
													))}
												</div>
											) : (
												<div className="flex-row">
													{this.state.badgeDesign ? (
														<div
															className="flex-row"
															onClick={() => this.downloadPNG("badge")}
															style={{ cursor: "pointer", marginRight: "30px" }}
														>
															{this.state.isLoadingPng.badge ? (
																<Spinner
																	id="pdf-spinner"
																	className="spinner-border"
																	animation="border"
																/>
															) : (
																<img
																	alt="verified"
																	className="download-icon"
																	src={
																		require("../../assets/common/badge-icon-black.svg")
																			.default
																	}
																/>
															)}
															<span className="s4">PNG</span>
														</div>
													) : (
														""
													)}
													{this.state.design ? (
														<div className="flex-row">
															<div
																className="flex-row"
																style={{
																	cursor: "pointer",
																	marginRight: "30px",
																}}
																onClick={this.downloadPdf}
															>
																{this.state.isLoadingPdf ? (
																	<Spinner
																		id="pdf-spinner"
																		className="spinner-border"
																		animation="border"
																	/>
																) : (
																	<img
																		alt="verified"
																		className="download-icon"
																		src={
																			require("../../assets/common/certificate-icon-black.svg")
																				.default
																		}
																	/>
																)}
																<span className="s4">PDF</span>
															</div>
															<div
																className="flex-row"
																onClick={() => this.downloadPNG("certificate")}
																style={{
																	cursor: "pointer",
																	marginRight: "30px",
																}}
															>
																{this.state.isLoadingPng.certificate ? (
																	<Spinner
																		id="pdf-spinner"
																		className="spinner-border"
																		animation="border"
																	/>
																) : (
																	<img
																		alt="verified"
																		className="download-icon"
																		src={
																			require("../../assets/common/certificate-icon-black.svg")
																				.default
																		}
																	/>
																)}
																<span className="s4">PNG</span>
															</div>
														</div>
													) : (
														""
													)}
												</div>
											)}
										</div>
									</div>
								</div>
							</div>
						) : (
							<div className="div-out">
								<div
									className="main-container"
									style={{
										flexDirection: "column",
										height: "450px",
										justifyContent: "flex-start",
										paddingTop: "5%",
										paddingLeft: "16px",
										paddingRight: "16px",
									}}
								>
									<span style={{ fontSize: "32px", fontWeight: "780" }}>
										<Translate id="notFound1" />
									</span>

									<span
										style={{
											textAlign: "center",
											fontSize: "24px",
											fontWeight: "0px",
										}}
									>
										<Translate id={`${this.state.errorMessage}2`} />
									</span>
									<span
										className="report-issue"
										onClick={() =>
											this.state.errorMessage === "deleted"
												? this.handleMailTo("deletedCertificate")
												: this.handleMailTo("reportNotFound")
										}
									>
										<Translate
											id={
												this.state.errorMessage === "deleted"
													? "contactIssuer"
													: "reportIssue"
											}
										/>
									</span>
									<img
										alt="verified"
										src={no_result}
										style={{ height: "246px", paddingTop: "3%" }}
									/>
								</div>
							</div>
						)}
						{!this.props.isLoading && this.state.dialogOpen ? (
							<LinkedinSharePopUp
								dialogOpen={this.state.dialogOpen}
								handleClose={this.handleClose}
								resetLinkedinAuthCode={this.resetLinkedinAuthCode}
								handleUncreatedImage={this.state.handleUncreatedImage}
								url={
									this.state.url && !this.state.badgeUrl
										? this.state.url
										: this.state.badgeUrl
								}
								issued_by={this.state.issued_by}
								credential_name={this.state.certificateName}
								articleUrl={window.location.href.toString().split("?")[0]}
								tokenCode={this.state.linkedinAccessToken}
								addTranslation={this.props.addTranslation}
								translate={this.props.translate}
								userId={this.state.linkedinUserId}
								credential_no={this.state.credno}
								organizationId={this.state.organizationId}
								certificate_url={this.state.url}
								badge_url={this.state.badgeUrl}
								shareText={this.state.socialShareText}
							/>
						) : null}
					</div>
				</div>
			);
		}
	}
}

export default withLocalize(Verify);
